import { createReducer } from "@reduxjs/toolkit";
import { retrieveApprovedFundingRequests } from "./retrieve-approved-funding-requests";
import type { RetrievalState } from "@redux/state/shared-types";
import type { ApprovedFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<ApprovedFundingRequestVM[]> = {
  fetching: "idle",
  data: [],
};

export const retrieveApprovedFundingRequestsReducer = createReducer<RetrievalState<ApprovedFundingRequestVM[]>>(initialState, builder => {
  builder.addCase(retrieveApprovedFundingRequests.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveApprovedFundingRequests.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveApprovedFundingRequests.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
